import { Component, Input } from '@angular/core'
import { coerceBooleanProperty } from '@angular/cdk/coercion'

@Component({
  selector: 'lin-layout-section-upd',
  templateUrl: './section-upd.component.html',
  styleUrls: ['./section-upd.component.scss'],
  standalone: false,
})
export class SectionUpdComponent {
  @Input() title: string
  @Input() multiline = false
  @Input()
  set scrollable(value) {
    this._scrollable = coerceBooleanProperty(value)
  }
  get scrollable() {
    return this._scrollable
  }

  private _scrollable = false
}
